import { isEmpty } from 'lodash';
import dayjs from 'dayjs';

export function formatEventDate(startDate, endDate, options = {
  singleDayFormat: 'DD MMMM YYYY',
}) {

  const startDateSameAsEnd = dayjs(dayjs(startDate, 'DD-MM-YYYY')).isSame(dayjs(endDate, 'DD-MM-YYYY'));

  if (isEmpty(endDate) || startDateSameAsEnd) {
    return dayjs(startDate, 'DD-MM-YYYY').format(options.singleDayFormat);
  }

  return `${dayjs(startDate, 'DD-MM-YYYY').format('DD')} - ${dayjs(endDate, 'DD-MM-YYYY').format('DD')} ${dayjs(startDate, 'DD-MM-YYYY').format('MMMM YYYY')}`;
}
